(function () {
  function initiateWeissmanVideos(videos) {
    for (var id in videos) {
      var videoInfo = videos[id];
      var videoTag = document.getElementById(id);
      var quality = getVideoQuality(videoInfo, videoTag);
      var content = '';
      var poster = '';

      if (quality != 'low') {
        var media = videoInfo[quality].media;
        var fallback = videoInfo[quality].fallback;
        for (var i in media) {
          item = media[i];
          content += '<source src="' + item.url + '" type="' + item.type + '">';
        }
        content += '<picture>';
        for (var i in fallback) {
          item = fallback[i];
          content += '<source src="' + item.url + '" type="' + item.type + '" />';
        }
        poster = ' poster="' + fallback[0].url + '"';
        content += '</picture>';

        $(videoTag).parent().empty().append('<video id="' + id + '"' + poster + ' preload="none" loop muted playsinline>' + content + '</video>');
      }
    }
  }

  function getVideoQuality(videoInfo, videoTag) {
    var quality;
    var qualities = ['low', 'med', 'high'];
    var width = isRetina()
      ? videoTag.offsetWidth * 2
      : videoTag.offsetWidth;

    for (var i in qualities) {
      quality = qualities[i];
      if (videoInfo[quality].maxWidth && videoInfo[quality].maxWidth > width) {
        break;
      }
    }

    return quality;
  }

  window.addEventListener("DOMContentLoaded",function() {
    if (window.weissmanVideos && Object.keys(window.weissmanVideos).length > 0) {
      initiateWeissmanVideos(window.weissmanVideos);

      // Add and invoke the scroll handler.
      $(window).scroll(weissmanVideosScrollHandler);
    }
  });

  function weissmanVideosScrollHandler () {
    $('video[playsinline]').each(function() {
      var isPlaying = this.isPlaying;
      if (isScrolledIntoView(this)) {
        if (!isPlaying) {
          this.play();
        }
      } else {
        if (isPlaying) {
          this.pause();
        }
      }
    })
  }

  function isScrolledIntoView(element)
{
    var $window = $(window);
    var $element = $(element);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $element.offset().top;
    var elemBottom = elemTop + $element.height();

    if (
      (elemTop >= docViewTop && elemTop <= docViewBottom) ||
      (elemBottom >= docViewTop && elemBottom <= docViewBottom) ||
      (elemTop <= docViewTop && elemBottom >= docViewBottom)
    ) {
      return true;
    }

    return false;
  }

  function isRetina() {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2));
  }

  Object.defineProperty(HTMLMediaElement.prototype, 'isPlaying', {
    get: function(){
      return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
  })

})();
